import { render, staticRenderFns } from "./time-widget.vue?vue&type=template&id=dd427cfa&scoped=true"
import script from "./time-widget.vue?vue&type=script&lang=js"
export * from "./time-widget.vue?vue&type=script&lang=js"
import style0 from "./time-widget.vue?vue&type=style&index=0&id=dd427cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd427cfa",
  null
  
)

export default component.exports